module.exports = __webpack_public_path__ + "static/usersegmentation-1f4bdb7641d626a86eade5acbdd1a017.svg";